import { CcLibraryHeading, CcLibraryHeadingList } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setCcLibraryHeadingList = (headingList: CcLibraryHeadingList) => ({
    type: inferLiteral(types.CC_LIBRARY_HEADING_LIST),
    headingList,
})
export const setCcLibraryHeadingEdit = (heading: CcLibraryHeading) => ({
    type: inferLiteral(types.CC_LIBRARY_HEADING_EDIT),
    heading,
})
export const setCcLibraryHeadingReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.CC_LIBRARY_HEADING_RELOAD_EDIT),
    value,
})
export const setCcLibraryHeadingAvailableParents = (parents: CcLibraryHeading[]) => ({
    type: inferLiteral(types.CC_LIBRARY_HEADING_AVAILABLE_PARENTS),
    parents,
})
export const setCcLibraryHeadingAvailableParentsFiltered = (parentsFiltered: CcLibraryHeading[]) => ({
    type: inferLiteral(types.CC_LIBRARY_HEADING_AVAILABLE_PARENTS_FILTERED),
    parentsFiltered,
})
export const setCcLibraryHeadingAvailableParentSearch = (search: string) => ({
    type: inferLiteral(types.CC_LIBRARY_HEADING_AVAILABLE_PARENT_SEARCH),
    search,
})
export const setCcLibraryHeadingMenu = (
    targetId: number,
    targetElement: HTMLElement,
) => ({
    type: inferLiteral(types.CC_LIBRARY_HEADING_MENU),
    targetId,
    targetElement,
})
export const setCcLibraryHeadingConfirmDelete = (heading: CcLibraryHeading) => ({
    type: inferLiteral(types.CC_LIBRARY_HEADING_CONFIRM_DELETE),
    heading,
})
